module.exports = __webpack_public_path__ + "img/qt.9808375e.png";